import _BaseAPIService from "../../_BaseAPIService";

const apiService = _BaseAPIService.instance;
const slug = "api";

const CounterCashServices = {
  getList: async () => {
    const response = await apiService.get(
      `/${slug}/countercashtransaction/coutercashtransaction`
    );
    return response.data;
  },
};

export default CounterCashServices;
